export default "__VITE_ASSET__d26aa8fb__"